<mat-card class="padding all margin all">
  <mat-card-header class="header-container padding all">
    <mat-card-title>Structure: {{ structure?.name || 'N/A' }}</mat-card-title>
    <!-- <div class="row label margin left right lg" *ngIf="keySystem" justify="flex-end">
      <label> Assigned To </label>
    </div> -->
    <div class="margin bottom center" *ngIf="keySystem">
      <mat-form-field floatLabel="always" appearance="outline" class="custom-width padding lrg top">
        <mat-label> Assigned To </mat-label>
        <mat-select [value]="lockedBy[0]?.name" [disabled]="disableUserChange">
          <mat-option *ngFor="let user of usersNamesList" [value]="user.name" (click)="changeUser(structure, user.id)">
            <div class="row">
              <div>{{ user.name }}</div>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
      
    </div>
    <div *ngIf="!editing" class="flex-end center">
      <button class="small-icon-button" (click)="toggleEdit()" mat-icon-button [disabled]="isReadOnly">
        <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
      </button>
      <button *ngIf="expanded" class="small-icon-button" (click)="expanded = !expanded" mat-icon-button>
        <mat-icon fontSet="material-icons-outlined">expand_more</mat-icon>
      </button>
      <button *ngIf="!expanded" class="small-icon-button" (click)="expanded = !expanded" mat-icon-button>
        <mat-icon fontSet="material-icons-outlined">expand_less</mat-icon>
      </button>
    </div>

    <div *ngIf="editing" class="row flex-end center">
      <button mat-stroked-button (click)="toggleEdit()" class="margin left"> Cancel </button>

      <button
        mat-flat-button
        (click)="saveStructure()"
        class="margin left"
        [ngClass]="{
          'save-button': editStructureForm.valid
        }"
        [small]="true"
        [disabled]="!editStructureForm.valid"
      >
        Save
      </button>
    </div>
  </mat-card-header>
  <mat-divider></mat-divider>
  <div class="card-form padding bottom" *ngIf="editing">
    <form [formGroup]="editStructureForm" autocompete="off">
      <!-- Row 0 -->
      <div class="row full-width">
        <mat-form-field floatLabel="always" appearance="outline" class="full-width margin sm left">
            <mat-label
              for="orderId"
              [ngClass]="{
                'error-message': fieldHasError(editStructureForm, 'name'),
                focus: focus.name
              }"
            >
              Name
            </mat-label>

          <div class="row">
            <input
              id="name"
              [ngClass]="{
              error: fieldHasError(editStructureForm, 'name'),
              'focus-border': focus.name
              }"
              placeholder="Enter name"
              formControlName="name"
              (focus)="focusOn('name')"
              (focusout)="focusOn('name')"
              autocomplete="no"
              cdkFocusInitial
              matInput
              aria-describedby="name"
              autofocus
            />

            <mat-icon
              *ngIf="fieldHasError(editStructureForm, 'name')"
              [size]="24"
              class="error-icon"
            >warning
            </mat-icon>
          </div>

          <!-- Errors -->
          <div *ngFor="let validation of errorMessages.name">
            <div
              class="caption error-message margin lrg top"
              *ngIf="fieldHasErrorMessages(editStructureForm, validation, 'name')"
              id="keysErrors"
            >
              {{ validation.message }}
            </div>
          </div>
        </mat-form-field>
      </div>
      <!-- Country -->
      <div class="row full-width">
        <mat-form-field
          *ngIf="countries?.length > 0"
          floatLabel="always"
          appearance="outline"
          class="one-third-width margin sm right"
        >
          <mat-label
            [ngClass]="{
              'error-message': fieldHasError(editStructureForm, 'country'),
              focus: focus.country
            }"
          >
            Country
          </mat-label>

          <mat-select
            [ngClass]="{
              error: fieldHasError(editStructureForm, 'country'),
              'focus-border': focus.country
            }"
            (focus)="focusOn('country')"
            (focusout)="focusOn('country')"
            formControlName="country"
          >
            <mat-option *ngFor="let country of countries" [value]="country">
              {{ country.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- City -->
        <mat-form-field floatLabel="always" appearance="outline" class="one-third-width margin sm left right">
            <mat-label
              for="city"
              class=""
              [ngClass]="{
                'error-message': fieldHasError(editStructureForm, 'city'),
                focus: focus.city
              }"
            >
              City
            </mat-label>

          <div class="row">
            <input
              id="city"
              [ngClass]="{
              error: fieldHasError(editStructureForm, 'city'),
              'focus-border': focus.city
              }"
              placeholder="Enter city"
              formControlName="city"
              (focus)="focusOn('city')"
              (focusout)="focusOn('city')"
              autocomplete="no"
              cdkFocusInitial
              matInput
              aria-describedby="City errors"
            />

            <mat-icon
              *ngIf="fieldHasError(editStructureForm, 'city')"
              [size]="24"
              class="error-icon"
            >warning
            </mat-icon>
          </div>

          <!-- Errors -->
          <div *ngFor="let validation of errorMessages.city">
            <div
              class="caption error-message margin lrg top"
              *ngIf="fieldHasErrorMessages(editStructureForm, validation, 'city')"
              id="cityErrors"
            >
              {{ validation.message }}
            </div>
          </div>
        </mat-form-field>

        <!-- State -->
        <mat-form-field
        floatLabel="always"
        appearance="outline"
        class="one-third-width margin sm left"
      >
        <mat-label
          [ngClass]="{
            'error-message': fieldHasError(editStructureForm, 'state'),
            focus: focus.state
          }"
        >
          State
        </mat-label>

        <mat-select
          [ngClass]="{
            error: fieldHasError(editStructureForm, 'state'),
            'focus-border': focus.state
          }"
          (focus)="focusOn('state')"
          (focusout)="focusOn('state')"
          formControlName="state"
          [disabled]="states.length === 0"
        >
          <mat-option *ngIf="states.length === 0" disabled>
            No states available
          </mat-option>
          <mat-option *ngFor="let state of states" [value]="state">
            {{ state.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      </div>
      <div class="row full-width margin sm bottom left">
          <mat-checkbox
            (change)="hasDocs()"
            formControlName="hasDocuments"
            value="hasDocuments"
            [checked]="hasDocuments"
          >
            Has Documents</mat-checkbox
          >
      </div>
      <div class="row full-width margin sm bottom left">
          <mat-slide-toggle [color]="'primary'" (change)="toggleDealerSpec($event)" [checked]="keySystem?.isDealerKeySystem" [disabled]="keySystem?.topMasterKey || keySystem?.isDealerKeySystem">
            <span *ngIf="keySystem?.isDealerKeySystem" class="blue alignText">Dealer Specified</span>
            <span *ngIf="!keySystem?.isDealerKeySystem" class="alignText">Convert to Dealer Specified</span>
            <mat-icon aria-hidden="false" aria-label="Example info icon" matTooltip="Once a TMK is created, this option is no longer available.">info</mat-icon>

          </mat-slide-toggle>
      </div>
    </form>
  </div>

  <mat-card-content [@fadeInOnly] *ngIf="expanded" class="padding lrg all">
    <!-- Row 1 -->
    <div class="row full-width">
      <div class="col one-third-width">
        <div class="custom padding top">City</div>
        <div class="data">
          {{ structure?.city || 'N/A' }}
        </div>
      </div>
      <div class="col one-third-width">
        <div class="custom">Keyway Family</div>
        <div class="data">
          {{ keywayFamily?.name || 'N/A' }}
        </div>
      </div>
      <div class="col one-third-width">
        <div class="custom padding top">Has Documents</div>
        <div class="data">
          {{ structure?.hasDocuments ? 'Yes' : 'No' }}
        </div>
      </div>
    </div>

    <!-- Row 2 -->
    <div class="row full-width">
      <div class="col one-third-width">
        <div class="custom padding top">State</div>
        <div class="data">
          {{ structure?.stateCode || 'N/A' }}
        </div>
      </div>
      <div class="col one-third-width">
        <div class="custom">Combinating Rule</div>
        <div class="data">
          {{ combinatingRule?.name || 'N/A' }}
        </div>
      </div>
      <div class="col one-third-width">
        <div *ngIf="keySystem" class="custom padding top">Dealer Specified</div>
        <div *ngIf="keySystem" class="data">
          {{ keySystem?.isDealerKeySystem ? 'Yes' : 'No' }}
        </div>
      </div>
    </div>

    <!-- Row 3 -->
    <div class="row full-width">
      <div class="col one-third-width">
        <div class="custom padding top">Country</div>
        <div class="data">
          {{ structure?.countryCode || 'N/A' }}
        </div>
      </div>
      <div class="col one-third-width">
        <div class="custom padding top">Pins/Chambers</div>
        <div class="data">
          {{ chamberType(structure?.chamberTypeId) || 'N/A' }}
        </div>
      </div>
      <div *ngIf="keySystem" class="col one-third-width">
        <div class="custom padding top">Managed By</div>
        <div class="data">{{ managedBy }}</div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
